import axios from "axios";
import authentication from "@/authentication";

export default {
  baseUrl: process.env.VUE_APP_API_USERS_SERVICE_BASE,
  async loadParcelShieldUsers() {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/GetParcelShieldUsers`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async saveParcelShieldUser(user) {
    await authentication.isAuthenticated();
    return axios
      .post(`${this.baseUrl}/AddParcelShieldUser`, user, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async fetchRoles() {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/GetRoles`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async loadClients() {
    await authentication.isAuthenticated();
    return axios
      .get(process.env.VUE_APP_API_CLIENT_SERVICE_BASE + "/GetClients", {
        headers: { Authorization: "Bearer " + authentication.getToken() }
      })
      .then(response => {
        return response.data;
      });
  },
  async uniqueUserName(userName) {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/uniqueUserName?id=${userName}`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  }
};
